/**
 * Access-токен живёт только в памяти: ни localStorage, ни Redux.
 * Долгоживущий refresh лежит в httpOnly-cookie и фронту недоступен.
 *
 * Поколение сеанса растёт при входе, выходе и сбросе после потери сеанса. По нему обновление
 * токена узнаёт, что сеанс сменился, пока оно ждало ответа: такой ответ относится к сеансу,
 * которого уже нет, и не должен ни затереть токен нового входа, ни вернуть токен после выхода.
 */
let accessToken: string | null = null
let generation = 0
/** Поколение, которое открыла потеря сеанса (`endSession`); `null` — такого не было. */
let endedIn: number | null = null

export function getAccessToken(): string | null {
  return accessToken
}

/** Текущее поколение сеанса: обновление токена запоминает его на старте. */
export function getSessionGeneration(): number {
  return generation
}

/** Вход кладёт токен нового сеанса, выход и сброс — `null`. В обоих случаях начинается новое поколение. */
export function setAccessToken(token: string | null): void {
  accessToken = token
  generation += 1
}

/**
 * Сеанс потерян: бэк отказал в обновлении живого сеанса (P-AUTH-02#R-06). Токен стирается новым
 * поколением, и это поколение запоминается. Пока его не сменили вход или выход, ворота знают,
 * что сеанс кончился сам, и ведут на вход с плашкой «Сеанс завершён» (P-AUTH-02#U-11).
 */
export function endSession(): void {
  setAccessToken(null)
  endedIn = generation
}

/**
 * Сеанс кончился посреди работы, и с тех пор не было ни входа, ни выхода. Первый заход без
 * сеанса и выход сюда не относятся: там пользователь и так знает, почему он на входе.
 */
export function isSessionEnded(): boolean {
  return endedIn === generation
}

/**
 * Токен того же сеанса после refresh. Пишется, только если с начала обновления поколение
 * не сменилось; иначе — `false`, и остаётся то, что положили вход или выход.
 */
export function renewAccessToken(token: string, startedIn: number): boolean {
  if (startedIn !== generation) return false
  accessToken = token
  return true
}
